export const ADD_SLIDE_OUT = 'ADD_SLIDE_OUT';
export const DELETE_SLIDE_OUT = 'DELETE_SLIDE_OUT';
export const REPLACE_SLIDE_OUT = 'REPLACE_SLIDE_OUT';
